import {
	LoggedInUserServiceInterface,
	ProfileResult,
	SummaryResult,
} from '../../interfaces';
import { ChangePasswordProfileProps, ChangePasswordProfileResult, FavoriteLocationResult, LoginResult } from "../../interfaces/user.service.interface";
import { UserData } from "../../model/user.data";
import { UserProvider } from "../../providers";
import { CheetahShared } from "./cheetah.shared";
import { CheetahServiceConfig } from "./cheetah.types";

export class CheetahLoggedInUserService extends CheetahShared implements LoggedInUserServiceInterface {
	async getFavoriteLocationById(placeId: number): Promise<FavoriteLocationResult | null> {
		return this.fetch({
			url: `/api/places/${placeId}`,
			method: 'GET',
		}, false)
			.then((response) => {
				if (!response.ok) {
					return response.json().then((res) => ({ ...res, success: false }));
				}
				return response.json().then((res) => ({ ...res, success: true }));
			})
			.then(result => {
				return {
					id: result.data.id,
					integration_id: result.data.integration_id,
					label: result.data.label,
					address: result.data.address,
					city: result.data.city,
					state: result.data.state,
					zip_code: result.data.zip_code,
					success: result.success
				}
			});
	}

	async summary(): Promise<SummaryResult | null> {
		return this.fetch({
			url: '/api/summary',
			method: 'GET',
		}, false)
			.then(result => result.json())
			.then(result => {
				const tierIndex = result.data.tier.tiers
					.findIndex((tier: any) => tier.name === result.data.tier.current_tier.name);

				const currentTier = result.data.tier.tiers[tierIndex];
				const tierPoints = currentTier.metric_thresholds.tier_points;

				return {
					first_name: result.data.member.first_name,
					last_name: result.data.member.last_name,
					points: result.data.metrics.point.balance,
					tier: result.data.tier.current_tier.name,
					metrics: result.data.metrics,
					tier_data: result.data.tier,
					current_tier_data: currentTier,
				}
			});
	}

	profile(): Promise<ProfileResult | null> {
		return this.fetch({
			url: '/api/profile',
			method: 'GET',
		}, false)
			.then(result => result.json())
			.then(result => ({
				card_id: result.data.card_id,
				member_id: result.data.member_id,
				favorite_location: result.data.favorite_location,
				total_points_in_period: result.data.total_points_in_period,
				first_name: result.data.first_name,
				last_name: result.data.last_name,
				mobile_phone: result.data.mobile_phone,
				birthdate: result.data.birthdate,
				receive_sms_offers: result.data.receive_sms_offers,
				receive_mail_offers: result.data.receive_mail_offers,
				email: result.data.email,
				mailing_postal_code: result.data.mailing_postal_code,
				tier_period_end_date: result.data.tierperiodenddate
			}))
	}

	async refreshUserToken(updatedUser: UserData): Promise<LoginResult> {
		return this.fetch({
			url: '/oauth/token',
			method: 'POST',
			body: {
				grant_type: 'refresh_token',
				refresh_token: updatedUser.token?.refresh_token
			}
		}).then((response) => {
			if (!response.ok) {
				return response.json().then((res) => ({ ...res, success: false }));
			}
			return response.json().then((res) => ({ ...res, success: true }));
		}).then(response => {
			if (response.success) {
				UserProvider.update(new UserData({ token: response }))
			} else
				UserProvider.logout()
			return response
		})
	}

	async changePasswordProfile(changePasswordRequest: ChangePasswordProfileProps): Promise<ChangePasswordProfileResult> {
		return this.fetch({
			url: '/api/profile/change_password',
			method: 'PUT',
			body: {
				...changePasswordRequest
			}
		}, false).then((response) => {
			if (!response.ok) {
				return response.json().then((res) => ({ ...res, success: false }));
			}
			return response.json().then((res) => ({ ...res, success: true }));
		});
	}
}
